<script>
	import BBCNews from '$lib/assets/logos/bbc-news.svg';
	import SkyNews from '$lib/assets/logos/sky-news.svg';
	import TheOneShow from '$lib/assets/logos/the-one-show.svg';
	import SkySports from '$lib/assets/logos/sky-sports.svg';
	import Button from '$lib/components/ui/button/button.svelte';

	const NewsStation = [
		{ src: BBCNews, alt: 'BBC News', height: 'h-8' },
		{ src: SkyNews, alt: 'Sky News', height: 'h-7' },
		{ src: TheOneShow, alt: 'The One Show', height: 'h-9' },
		{ src: SkySports, alt: 'Sky Sports', height: 'h-7' }
	];
</script>

<div class="grid grid-cols-1 md:grid-cols-12 gap-12 py-12 md:py-24 items-center">
	<div class="md:col-span-7 space-y-6">
		<div
			class="inline-block px-4 py-1.5 bg-white shadow-pl rounded-full font-bold tracking-tight text-sm"
		>
			Who we are
		</div>
		<div class="font-title text-2xl md:text-4xl leading-tight">
			Planet League Mobilises Sports Fans to Take Impactful Social and Environmental Action
		</div>
		<div class="font-display font-bold text-lg">
			We team up with sports clubs, sponsors, schools and charities to run impactful campaigns for
			fans.
		</div>
		<p class="font-display leading-relaxed text-slate-600">
			Launched in 2019, Planet League has built partnerships with over 80 professional football
			clubs in the UK, including all 20 Premier League clubs. Millions of sports fans all over the
			world have engaged with our campaigns which are all grounded in fans taking action.
		</p>
		<Button href="/register" class="w-full md:w-fit">Register now</Button>
	</div>

	<div class="md:col-span-5 relative group w-full max-w-md mx-auto md:mx-0">
		<div
			class="absolute -inset-1 bg-primary-gradient rounded-[2.5rem] opacity-20 blur-xl group-hover:opacity-40 transition duration-1000"
		></div>

		<div
			class="relative flex flex-col justify-between rounded-2xl bg-white border border-slate-100 p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] overflow-hidden"
		>
			<div class="flex justify-between items-center mb-10">
				<span class="text-[10px] uppercase tracking-[0.3em] font-black text-planet-black3">
					Media Coverage
				</span>
				<div class="flex items-center gap-2 px-2 py-1 rounded-md bg-red-50 text-red-600">
					<span class="relative flex h-2 w-2">
						<span
							class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
						></span>
						<span class="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
					</span>
					<span class="text-[10px] font-bold uppercase tracking-wider">Featured on</span>
				</div>
			</div>

			<div class="grid grid-cols-2 gap-4">
				{#each NewsStation as station (station.src)}
					<div
						class="flex items-center justify-center p-6 rounded-2xl border border-slate-50 bg-slate-50/50 transition-all duration-300 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-1 group/logo"
					>
						<img
							src={station.src}
							alt={station.alt}
							class="{station.height} object-contain transition-all duration-500 grayscale opacity-60 group-hover/logo:grayscale-0 group-hover/logo:opacity-100 group-hover/logo:scale-110"
						/>
					</div>
				{/each}
			</div>

			<div class="mt-10 pt-6 border-t border-slate-50">
				<p class="text-sm font-medium text-slate-500 leading-relaxed">
					Planet League has been featured on major networks for our
					<span class="text-slate-900 font-bold">unique approach</span> to fan-led climate action.
				</p>
			</div>
		</div>
	</div>
</div>
